/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Sales_Meta_DescriptionInputs */

const id_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.title} dari Epic Games Store.`)
};

const ms_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.title} dari Epic Games Store.`)
};

const da_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.title} fra Epic Games Store.`)
};

const de_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entdecken Sie ${i?.title} im Epic Games Store.`)
};

const en_us2_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check out ${i?.title} from the Epic Games Store.`)
};

const es_es2_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre ${i?.title} de la Epic Games Store.`)
};

const es_mx2_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre ${i?.title} de la Epic Games Store.`)
};

const fil_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingnan ang ${i?.title} mula sa Epic Games Store.`)
};

const fr_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Découvrez ${i?.title} sur l'Epic Games Store.`)
};

const it_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scopri ${i?.title} dall'Epic Games Store.`)
};

const hu_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nézd meg a ${i?.title} ajánlatokat az Epic Games Store-ból.`)
};

const nl_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekijk ${i?.title} van de Epic Games Store.`)
};

const no_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sjekk ut ${i?.title} fra Epic Games Store.`)
};

const pl_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprawdź ${i?.title} z Epic Games Store.`)
};

const pt_br2_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confira ${i?.title} na Epic Games Store.`)
};

const pt_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulte ${i?.title} da Epic Games Store.`)
};

const ro_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vezi ${i?.title} din Epic Games Store.`)
};

const fi_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutustu ${i?.title} Epic Games Storesta.`)
};

const sv_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kolla in ${i?.title} från Epic Games Store.`)
};

const vi_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem ${i?.title} từ Epic Games Store.`)
};

const tr_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki ${i?.title} inceleyin.`)
};

const cs_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podívejte se na ${i?.title} z Epic Games Store.`)
};

const bg_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вижте ${i?.title} от Epic Games Store.`)
};

const ru_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посмотрите ${i?.title} из Epic Games Store.`)
};

const uk_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перегляньте ${i?.title} з Epic Games Store.`)
};

const ar_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصفح ${i?.title} من Epic Games Store.`)
};

const hi_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store से ${i?.title} देखें।`)
};

const th_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดู ${i?.title} จาก Epic Games Store`)
};

const ja_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store の ${i?.title} をチェック。`)
};

const zh_cn2_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看来自Epic游戏商城的 ${i?.title}。`)
};

const zh_hant1_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`檢視來自Epic遊戲商城的 ${i?.title}。`)
};

const ko_sales_meta_description = /** @type {(inputs: Sales_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 ${i?.title}을(를) 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Check out {title} from the Epic Games Store." |
*
* @param {Sales_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_meta_description = /** @type {((inputs: Sales_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_meta_description(inputs)
	if (locale === "ms") return ms_sales_meta_description(inputs)
	if (locale === "da") return da_sales_meta_description(inputs)
	if (locale === "de") return de_sales_meta_description(inputs)
	if (locale === "en-US") return en_us2_sales_meta_description(inputs)
	if (locale === "es-ES") return es_es2_sales_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_sales_meta_description(inputs)
	if (locale === "fil") return fil_sales_meta_description(inputs)
	if (locale === "fr") return fr_sales_meta_description(inputs)
	if (locale === "it") return it_sales_meta_description(inputs)
	if (locale === "hu") return hu_sales_meta_description(inputs)
	if (locale === "nl") return nl_sales_meta_description(inputs)
	if (locale === "no") return no_sales_meta_description(inputs)
	if (locale === "pl") return pl_sales_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sales_meta_description(inputs)
	if (locale === "pt") return pt_sales_meta_description(inputs)
	if (locale === "ro") return ro_sales_meta_description(inputs)
	if (locale === "fi") return fi_sales_meta_description(inputs)
	if (locale === "sv") return sv_sales_meta_description(inputs)
	if (locale === "vi") return vi_sales_meta_description(inputs)
	if (locale === "tr") return tr_sales_meta_description(inputs)
	if (locale === "cs") return cs_sales_meta_description(inputs)
	if (locale === "bg") return bg_sales_meta_description(inputs)
	if (locale === "ru") return ru_sales_meta_description(inputs)
	if (locale === "uk") return uk_sales_meta_description(inputs)
	if (locale === "ar") return ar_sales_meta_description(inputs)
	if (locale === "hi") return hi_sales_meta_description(inputs)
	if (locale === "th") return th_sales_meta_description(inputs)
	if (locale === "ja") return ja_sales_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_meta_description(inputs)
	return ko_sales_meta_description(inputs)
});
export { sales_meta_description as "sales.meta.description" }